export class Service {
  public name: string;
  public organizationId: string;
  public settings: string;
}
